import { Switch as MantineSwitch, SwitchProps } from "@mantine/core";

type Props = {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
} & Omit<SwitchProps, "label" | "checked" | "onChange">;

export const Switch = ({ label, checked, onChange, ...restProps }: Props) => {
  return (
    <MantineSwitch
      label={label}
      checked={checked}
      onChange={e => onChange(e.currentTarget.checked)}
      {...restProps}
    />
  );
};
